module.exports = __webpack_public_path__ + "./assets/icons/5baa597861_50153774_fotolia-stockphoto-graf.jpg";